import SGWSLogo from "@/images/companies/sgws.webp";
import CallstackLogo from "@/images/companies/callstack.webp";
import AgodaLogo from "@/images/companies/agoda.webp";
import NxLogo from "@/images/companies/nx.webp";
import RimacLogo from "@/images/companies/rimac.webp";
import BigCommerceLogo from "@/images/companies/bigcommerce.webp";

export const companyLogos = [
  {
    src: SGWSLogo,
    alt: "SGWS",
    url: "https://www.southernglazers.com/",
  },
  {
    src: CallstackLogo,
    alt: "Callstack",
    url: "http://callstack.com/",
  },
  {
    src: AgodaLogo,
    alt: "Agoda",
    url: "https://agoda.com/",
  },
  {
    src: NxLogo,
    alt: "Nx",
    url: "https://nx.dev/",
  },
  {
    src: RimacLogo,
    alt: "Rimac",
    url: "https://rimac.com.pe/",
  },
  {
    src: BigCommerceLogo,
    alt: "BigCommerce",
    url: "https://bigcommerce.com/",
  },
];